module.exports = __webpack_public_path__ + "static/img/slv.98a3ef8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/slv.svg
// module id = BfYO
// module chunks = 0